import { render } from "./ReportPage.vue?vue&type=template&id=727468c2&scoped=true"
import script from "./ReportPage.vue?vue&type=script&lang=js"
export * from "./ReportPage.vue?vue&type=script&lang=js"

import "./ReportPage.vue?vue&type=style&index=0&id=727468c2&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727468c2"]])

export default __exports__